import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {TuiCarouselComponent} from '@taiga-ui/kit';
import {DamElasticDTO, DamItemVersion, FileService, ListTable} from 'compob2b-libs';
import {catchError, take} from 'rxjs/operators';
import {DamService} from '../../../dam.service';
import {DamItemVersionTypeCountWSelected} from '../dam-catalog.component';

@Component({
  selector: 'app-dam-element-preview',
  templateUrl: './dam-element-preview.component.html',
  styleUrls: ['./dam-element-preview.component.scss']
})
export class DamElementPreviewComponent extends ListTable {

  constructor(
    public damService: DamService,
    public fileService: FileService
  ) {
    super();
  }

  @Input() damElement: DamElasticDTO = null;

  @Input() set _damElement(value: DamElasticDTO) {
    this.carouselIndex = 0;
    this.filteredVersions = 0;
    this.damElement = value;
    this.cdr.detectChanges();
  }

  @Input() damItemVersions: DamItemVersion[] = [];
  @Input() damItemVersionWithDocumentInfoExtensions: string[] = [];
  @Input() fileExtensions: DamItemVersionTypeCountWSelected[] = [];
  // damItemVersionWithDocumentInfoExtensionsCount^
  @Input() isOpen = false;
  @Output() closeEvent = new EventEmitter<boolean>();
  @Output() elementShareEvent = new EventEmitter<DamElasticDTO>();

  @ViewChild('carousel', {static: true}) carousel: TuiCarouselComponent;
  carouselIndex = 0;
  filteredVersions = 0;

  setCarouselIndex(index: number): void {
    this.carouselIndex = index;
    console.log('setCarouselIndex', this.carouselIndex);
    this.cdr.detectChanges();
  }

  close() {
    this.isOpen = false;
    this.carouselIndex = 0;
    this.closeEvent.emit(true);
  }

  isAllExtensionsSelected = false;

  onAllFileExtensionsToggle(isSelected: boolean): void {
    this.toggleAll(this.fileExtensions, isSelected);
  }

  onFileExtensionToggle(index: number): void {
    this.fileExtensions[index].selected = !this.fileExtensions[index].selected;
    this.isAllExtensionsSelected = this.allItemsSelected(this.fileExtensions);
    this.filterVersions(this.damItemVersions);
  }

  allItemsSelected<T extends { selected: boolean }>(items: T[]): boolean {
    return (items.every(item => item?.selected));
  }

  allItemsUnselected<T extends { selected: boolean }>(items: T[]): boolean {
    return (items.every(item => !item?.selected));
  }

  toggleAll<T extends { selected: boolean }>(items: T[], selected: boolean) {
    this.isAllExtensionsSelected = selected;
    items.forEach(item => item.selected = selected);
    this.filterVersions(this.damItemVersions);
  }

  filterVersions(damItemVersions: DamItemVersion[]) {
    if (this.allItemsUnselected(this.fileExtensions)) {
      return damItemVersions;
    }

    const selectedExtensionsNames: string[] = this.fileExtensions.map(extension => {
      if (extension.selected) {
        return extension.typeOfFile;
      }
    }).filter(Boolean);

    this.filteredVersions = this.damItemVersions.filter((version: DamItemVersion) => {
      return selectedExtensionsNames.includes(version.mimeType);
    }).length;

    this.carouselIndex = 0;
    return damItemVersions.filter((version: DamItemVersion) => {
      return selectedExtensionsNames.includes(version.mimeType);
    });
  }

  changeApproved(damItemId: number, value: boolean) {
    this.compoApiService.post('/dam/item/' + damItemId + '/change-approved', {
      value: value
    }).pipe(take(1), catchError(err => this.handleError(err))).subscribe();
  }

  changeEnabled(damItemId: number, value: boolean) {
    this.compoApiService.post('/dam/item/' + damItemId + '/change-enabled', {
      value: value
    }).pipe(take(1), catchError(err => this.handleError(err))).subscribe();
  }

  changeDeleted(damItemId: number, value: boolean) {
    this.compoApiService.post('/dam/item/' + damItemId + '/change-deleted', {
      value: value
    }).pipe(take(1), catchError(err => this.handleError(err))).subscribe();
  }

  downloadDamItemVersion(id: number, header: string): void {
    this.fileService.downloadUrl('/dam/download/' + this.damItemVersions[this.carouselIndex].id)
      .subscribe(response => {
        FileService.saveAs(response, this.damItemVersions[this.carouselIndex].header);
      });
  }

  share(damElement: DamElasticDTO) {
    this.elementShareEvent.emit(damElement);
  }
}
